(function () {
  'use strict';

  const classes = {
    hamburgerActive: 'header__hamburger--active',
    hamburgerMenuActive: 'header__navigation__menu--active',
    hamburgerMenuSticky: 'header__hamburger-content--sticky',
    headerSticky: 'header--sticky',
    headerContactInformationActive: 'header__navigation__contact--information--active',
  };

  const selectors = {
    burgerButton: '.js-burger-button',
    header: '.header',
    stage: '.stage',
    hamburgerContentMenu: '.header__navigation__menu',
    headerContactInformation: '.header__navigation__contact--information',
    section: 'section',
    dropdown: '.header__navigation__dropdown',
    dropdownIcon: '.header__navigation__dropdown__icon',
    childrenMenu: '.header__navigation__children',
  };

  const breakpoints = {
    tablet: 1024,
    mobile: 480,
  };


  let hamburgerButton, headerContactInformation, menuContent, header;
  let isMobile = window.innerWidth <= breakpoints.tablet;

  const onClickBurger = () => {
    hamburgerButton.classList.toggle(classes.hamburgerActive);
    menuContent.classList.toggle(classes.hamburgerMenuActive);
    headerContactInformation.classList.toggle(classes.headerContactInformationActive);

    // Bouton animation
    const currentState = hamburgerButton.getAttribute("data-state");

    if (!currentState || currentState === "closed") {
      hamburgerButton.setAttribute("data-state", "opened");
      hamburgerButton.setAttribute("aria-expanded", "true");

      document.querySelector(".line.top").setAttribute("data-state", "opened");
      document.querySelector(".line.middle").setAttribute("data-state", "opened");
      document.querySelector(".line.bottom").setAttribute("data-state", "opened");
    } else {
      hamburgerButton.setAttribute("data-state", "closed");
      hamburgerButton.setAttribute("aria-expanded", "false");

      document.querySelector(".line.top").setAttribute("data-state", "closed");
      document.querySelector(".line.middle").setAttribute("data-state", "closed");
      document.querySelector(".line.bottom").setAttribute("data-state", "closed");
    }

    // Mobile/tablet, désactiver le scroll du body quand menu ouvert
    document.body.style.overflow = menuContent.classList.contains(classes.hamburgerMenuActive) ? 'hidden' : '';
  };

  const analyseStickyPosition = () => {
    const stage = document.querySelector(selectors.stage);

    if (stage) {
      const observer = new IntersectionObserver(
        entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) {
              header.classList.add(classes.headerSticky);
              menuContent.classList.add(classes.hamburgerMenuSticky);
            } else {
              header.classList.remove(classes.headerSticky);
              menuContent.classList.remove(classes.hamburgerMenuSticky);
            }
          });
        },
        { threshold: [0] }
      );

      observer.observe(stage);
    }
  };

  const toggleDropdown = (event) => {
    const dropdown = event.currentTarget.closest(selectors.dropdown);
    event.preventDefault();

    if (!dropdown) return;

    const isOpen = dropdown.classList.contains('header__navigation__dropdown--is-open');

    document.querySelectorAll(selectors.dropdown).forEach((item) => {
      item.classList.remove('header__navigation__dropdown--is-open');
    })

    if (!isOpen) {
      dropdown.classList.add('header__navigation__dropdown--is-open')
    }

  }

  const initDropdownBehavior = () => {
    const dropdowns = document.querySelectorAll(selectors.dropdown);

    dropdowns.forEach((dropdown) => {
      const icon = dropdown.querySelector(selectors.dropdownIcon);

      if (!icon) return;

      if (isMobile) {
        icon.addEventListener('click', toggleDropdown)
      } else {
        icon.removeEventListener('click', toggleDropdown)
      }
    })

  }

  const onResize = () => {
    const currentIsMobileOrTablet = window.innerWidth <= breakpoints.tablet;

    if (currentIsMobileOrTablet !== isMobile) {
      isMobile = currentIsMobileOrTablet;
      initDropdownBehavior();
    }

    // Réinitialiser l'état du burger menu + le scroll sur le body lors du passage sur desktop.
    if (!currentIsMobileOrTablet) {
      document.body.style.overflow = '';
      hamburgerButton.classList.remove(classes.hamburgerActive);
      menuContent.classList.remove(classes.hamburgerMenuActive);
      headerContactInformation.classList.remove(classes.headerContactInformationActive);
      hamburgerButton.removeAttribute("data-state");
      hamburgerButton.setAttribute("aria-expanded", "false")
      document.querySelector(".line.top").removeAttribute("data-state");
      document.querySelector(".line.middle").removeAttribute("data-state");
      document.querySelector(".line.bottom").removeAttribute("data-state");
    }
  }

  const init = () => {
    hamburgerButton = document.querySelector(selectors.burgerButton);
    menuContent = document.querySelector(selectors.hamburgerContentMenu);
    header = document.querySelector(selectors.header);
    headerContactInformation = document.querySelector(selectors.headerContactInformation);

    if (hamburgerButton instanceof HTMLElement) {
      hamburgerButton.addEventListener('click', onClickBurger);
    }

    analyseStickyPosition();
    initDropdownBehavior()
    window.addEventListener('resize', onResize)
  };

  window.addEventListener('load', init);
})();
